<template>
   <nav class="mainNav">
       <ul>
           <li>
               <router-link to="/">{{ $t("global.menu_features")}}</router-link>
            </li>
           <li>
               <router-link to="/customer-needs">{{ $t("global.menu_customer_needs") }}</router-link>
            </li>
           <li class="signal">
               <router-link to="/signal-store">{{ $t("global.menu_signal_store") }}</router-link>
            </li>
       </ul>
   </nav>
</template>

<script>
export default {

}
</script>

<style>
.mainNav {
    display: flex;
    background-color: transparent;
    padding-left: 86px;
}

.mainNav ul {
    font-family: "CorpBold";
    font-size: 22px;
    list-style: none;
}

.mainNav ul li {
    display: inline-block;
}

.mainNav ul li:first-of-type {
    margin-right: 15px;
}

.mainNav ul li:last-of-type {
    margin-left: 15px;
}

.mainNav ul li:not(:first-child):not(:last-child){
    margin: 0 15px;
}

.mainNav ul li a {
    position: relative;
    color: #000;
    text-decoration: none;
}

.mainNav ul li a:hover {
    color: #3ACFA2;
    text-decoration: none;
}

.mainNav ul .signal a:hover {
    color: #363636;
    text-decoration: none;
}


.mainNav ul li a:hover::after {
    content: "";
    position: absolute;
    left: calc(50% - 14px);
    right: calc(50% - 14px);
    top: 25px;
    border-bottom: 5px solid #3ACFA2;
    border-radius: 20px;
    width: 28px;
}

.mainNav ul .signal a:hover::after {
    content: "";
    position: absolute;
    left: calc(50% - 14px);
    right: calc(50% - 14px);
    top: 25px;
    border-bottom: 5px solid #363636;
    border-radius: 20px;
    width: 28px;
}

.mainNav ul li a.router-link-exact-active {
    color: #3ACFA2;
    text-decoration: none;
}

.mainNav ul .signal a.router-link-exact-active {
    color: #363636;
    text-decoration: none;
}

.mainNav ul li a.router-link-exact-active::after {
    content: "";
    position: absolute;
    left: calc(50% - 14px);
    right: calc(50% - 14px);
    top: 25px;
    border-bottom: 5px solid #3ACFA2;
    border-radius: 20px;
}

.mainNav ul .signal a.router-link-exact-active::after {
    content: "";
    position: absolute;
    left: calc(50% - 14px);
    right: calc(50% - 14px);
    top: 25px;
    border-bottom: 5px solid #363636;
    border-radius: 20px;
}
</style>